import React, { useState, useRef, useEffect } from 'react';
import t from 'prop-types'; // import { DraggableCore } from 'react-draggable'

import { is_touch_device } from '../../util';
import useStatePosicionEnRango from '../../util/use-state-posicion-en-rango';
import useArrastrable from '../../util/use-arrastrable';
var NOMBRE_EVENTO_ACTIVAR_EDITOR = is_touch_device() ? 'touchend' : 'mouseup';

function NotaFlotante(_ref) {
  var x = _ref.x,
      y = _ref.y,
      offset = _ref.offset,
      minX = _ref.minX,
      maxX = _ref.maxX,
      onMover = _ref.onMover,
      onActivarEdicion = _ref.onActivarEdicion;

  var _useStatePosicionEnRa = useStatePosicionEnRango(x, y, minX, maxX, 0, 99),
      pos = _useStatePosicionEnRa[0],
      setPos = _useStatePosicionEnRa[1];

  var _useState = useState(false),
      recienArrastrado = _useState[0],
      setRecienArrastrado = _useState[1];

  var rootRef = useRef(null);

  var _useArrastrable = useArrastrable({
    elementRef: rootRef,
    onArrastrando: function onArrastrando(posicion) {
      return setPos(posicion);
    },
    onStop: function onStop(_ref2) {
      var x = _ref2.x,
          y = _ref2.y;
      onMover && onMover(x, y);
      setRecienArrastrado(true);
    }
  }),
      arrastrando = _useArrastrable.arrastrando;

  useEffect(function () {
    function handleActivarEditor(e) {
      if (arrastrando || recienArrastrado) {
        setRecienArrastrado(false);
        return;
      }

      onActivarEdicion && onActivarEdicion();
    }

    var elemento = rootRef.current;
    elemento.addEventListener(NOMBRE_EVENTO_ACTIVAR_EDITOR, handleActivarEditor);
    return function () {
      return elemento.removeEventListener(NOMBRE_EVENTO_ACTIVAR_EDITOR, handleActivarEditor);
    };
  }, [arrastrando, recienArrastrado, rootRef, onActivarEdicion]);
  var style = {
    left: pos.x + offset.x + '%',
    top: pos.y + offset.y + '%',
    // whiteSpace: 'normal',
    // zIndex: 10, 
    pointerEvents: "auto",
    cursor: arrastrando ? 'move' : 'pointer' // width: '10%',
    // height: '6%',
    // backgroundImage: 'url(css/imagenes/barra-herramientas/herramientaNota.png)',
    // backgroundSize: 'cover'

  };
  return React.createElement('div', {
    className: 'botonNotaEnPagina',
    style: style,
    ref: rootRef
  });
}

NotaFlotante.propTypes = process.env.NODE_ENV !== "production" ? {
  texto: t.string.isRequired,

  /** posicion horizontal del editor relativa a su contenedor y en porcentaje, ejemplo: 10 para 10% */
  x: t.number.isRequired,

  /** posicion vertical del editor relativa a su contenedor y en porcentaje, ejemplo: 10 para 10% */
  y: t.number.isRequired,

  /** offset que se suma a las coordenadas para renderizar el componente. Opcional */
  offset: t.shape({
    x: t.number.isRequired,
    y: t.number.isRequired
  }),

  /** minimo valor de x */
  minX: t.number,

  /** maximo valor de x */
  maxX: t.number,

  /** 
   * Evento que lanza el componente para informar de la nueva posición del texto. 
   * Se llamará con los parametros: (x, y) => {...} 
   * 
   * */
  onMover: t.func.isRequired,

  /**
   * Evento que lanza el componente para informar de que el usuario quiere editar el texto.
   */
  onActivarEdicion: t.func.isRequired
} : {};
NotaFlotante.defaultProps = {
  activo: true,
  x: 0,
  y: 0,
  offset: {
    x: 0,
    y: 0
  },
  minX: 0,
  maxX: 95 // class TextoFlotanteClase extends Component {
  //     static propTypes = {
  //         texto: t.string.isRequired,
  //         /** tamaño 'normal' de la fuente en pixels. 1em será tratado como de este tamaño. */
  //         tamFuenteBase: t.number.isRequired,
  //         /** posicion horizontal del editor relativa a su contenedor y en porcentaje, ejemplo: 10 para 10% */
  //         x: t.number.isRequired,
  //         /** posicion vertical del editor relativa a su contenedor y en porcentaje, ejemplo: 10 para 10% */
  //         y: t.number.isRequired, 
  //         /** offset que se suma a las coordenadas para renderizar el componente. Opcional */
  //         offset:  t.shape({
  //             x: t.number.isRequired,
  //             y: t.number.isRequired,
  //         }),
  //         /** si activo === false, el texto no se movera */
  //         activo: t.bool,
  //         /** minimo valor de x */
  //         minX: t.number,
  //         /** maximo valor de x */
  //         maxX: t.number,
  //         /** 
  //          * Evento que lanza el componente para informar de la nueva posición del texto. 
  //          * Se llamará con los parametros: (x, y) => {...} 
  //          * 
  //          * */ 
  //         onMover: t.func.isRequired,
  //         /**
  //          * Evento que lanza el componente para informar de que el usuario quiere editar el texto.
  //          */
  //         onActivarEdicion: t.func.isRequired
  //     }
  //     static defaultProps = {
  //         activo: true,
  //         x: 0,
  //         y: 0,        
  //         offset: {x: 0, y: 0},
  //         minX: 0,
  //         maxX: 95
  //     }
  //     constructor(props) {
  //         super(props);
  //         this.state = this.createStateFromProps(props);
  //     }
  //     createStateFromProps = props => {
  //         return {
  //             x: props.x,
  //             y: props.y,
  //             dragging: false,
  //             hasBeenDragged: false        
  //         }
  //     }
  //     componentDidUpdate(prevProps) {
  //         if (prevProps.x !== this.props.x || prevProps.y !== this.props.y ) {
  //             this.setState(this.createStateFromProps(this.props))
  //         }
  //     }
  //     handleStop = (e) => {
  //         if (!this.state.dragging) {
  //             return;
  //         }
  //         this.setState(
  //             {
  //                 dragging: false,
  //                 hasBeenDragged: true
  //             }, 
  //             () => {
  //                 const { x, y } = this.state
  //                 this.props.onMover(x, y)
  //             }
  //         );        
  //     }
  //     handleDrag = (e, data) => {      
  //         this.setState( prevState => {
  //             const rect = this.root.parentNode.getBoundingClientRect();
  //             return {
  //                 x: fixBounds(prevState.x + 100 * data.deltaX / rect.width, this.props.minX, this.props.maxX),
  //                 y: fixBounds(prevState.y + 100 * data.deltaY / rect.height, 0, 95),
  //                 dragging: true
  //             }
  //         })        
  //     }
  //     handleActivarEditor = e => {        
  //         e.preventDefault();
  //         this.setState( (prevState, props) => {
  //             if (prevState.dragging || prevState.hasBeenDragged) {
  //                 return { 
  //                     dragging: false,
  //                     hasBeenDragged: false                    
  //                 }
  //             }            
  //             this.props.onActivarEdicion();
  //         })        
  //     }
  //     render () {
  //         const {activo, offset, texto, tamFuenteBase} = this.props;    
  //         const style = {
  //             left: `${ this.state.x + offset.x }%`,
  //             top: `${ this.state.y + offset.y }%`,            
  //             whiteSpace: 'normal',
  //             fontSize: tamFuenteBase,
  //             zIndex: 10, //this.state.dragging ? 10 : 0,        
  //             pointerEvents: "auto"    
  //         }
  //         if (this.state.dragging) { style.cursor = 'move'; }
  //         const eventHandlers = {};
  //         eventHandlers[NOMBRE_EVENTO_ACTIVAR_EDITOR] = this.handleActivarEditor;
  //         return (    
  //             <DraggableCore onDrag={this.handleDrag} onStop={this.handleStop} disabled={!activo}>
  //                 <div className='textoUsuarioPagina' style={style} ref={root => this.root = root }>
  //                     <div {...eventHandlers}>
  //                         <span style={{fontSize: '1em' }} dangerouslySetInnerHTML={{__html: texto}} />
  //                     </div>
  //                 </div>
  //             </DraggableCore>
  //         );
  //     }
  // }

};
export default NotaFlotante;